import "../sass/style.scss";

jQuery(function () {
  const topSwiper = new Swiper ('#js-topSwiper', {
    slidesPerView: "auto",
    spaceBetween: 45,
    speed: 5000,
    autoplay: {
      delay: 0,
      disableOnInteraction: false,
    },
    allowTouchMove: true,
    centeredSlides : true,
    loop: true,
    navigation: {
      nextEl: ".swiper-btn-next",
      prevEl: ".swiper-btn-prev",
    },
    pagination: {
      el: '.swiper-pagination01',
      type: 'fraction',
    },
    breakpoints: {
      1024: {
        allowTouchMove: false,
      }
    },
  });

  $('a[href^="#"]').click(function(){
    let speed = 500;
    let href= $(this).attr("href");
    let target = $(href == "#" || href == "" ? 'html' : href);
    let position = target.offset().top;
    $("html, body").animate({scrollTop: position}, speed, "swing");
    return false;
  });

  $('.js-QandA_Q').each(function(){
    $(this).on('click',function(){
        $("+.js-QandA_A",this).stop().slideToggle();
        $(this).find(".QandA_Plus").toggleClass("minus");
        return false;
    });
});
});